<template>
  <div class="tw-flex tw-gap-2">
    <button
      v-if="can('ping')"
      class="tw-flex-1 tw-bg-blue-600 hover:tw-bg-blue-700 tw-text-white tw-rounded-lg tw-py-2 tw-px-3 tw-font-semibold tw-text-sm tw-transition-colors disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
      @click="$emit('ping')"
      :disabled="isPinging"
    >
      <span v-if="isPinging" class="tw-flex tw-items-center tw-justify-center tw-gap-1">
        <span class="tw-w-3 tw-h-3 tw-border-2 tw-border-white tw-border-t-transparent tw-rounded-full tw-animate-spin" />
        Pingen...
      </span>
      <span v-else class="tw-flex tw-items-center tw-justify-center tw-gap-1">
        <wifi-icon class="tw-w-4 tw-h-4" /> Ping
      </span>
    </button>
    <button
      v-if="can('poll')"
      class="tw-flex-1 tw-bg-blue-600 hover:tw-bg-blue-700 tw-text-white tw-rounded-lg tw-py-2 tw-px-3 tw-font-semibold tw-text-sm tw-transition-colors disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
      @click="$emit('poll')"
      :disabled="isPolling"
    >
      <span v-if="isPolling" class="tw-flex tw-items-center tw-justify-center tw-gap-1">
        <span class="tw-w-3 tw-h-3 tw-border-2 tw-border-white tw-border-t-transparent tw-rounded-full tw-animate-spin" />
        Pollen...
      </span>
      <span v-else class="tw-flex tw-items-center tw-justify-center tw-gap-1">
        <refresh-icon class="tw-w-4 tw-h-4" /> Poll
      </span>
    </button>
    <!-- Cast4all meters have no live readout, but a PV production test of a few minutes -->
    <button
      v-if="can('pv-test')"
      class="tw-flex-1 tw-bg-blue-600 hover:tw-bg-blue-700 tw-text-white tw-rounded-lg tw-py-2 tw-px-3 tw-font-semibold tw-text-sm tw-transition-colors disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
      @click="$emit('pv-production-test')"
      :disabled="isRunningPvTest"
      title="Cast4all-productietest: meet de teruglevering over een paar minuten (ca. 3-4 min)"
    >
      <span v-if="isRunningPvTest" class="tw-flex tw-items-center tw-justify-center tw-gap-1">
        <span class="tw-w-3 tw-h-3 tw-border-2 tw-border-white tw-border-t-transparent tw-rounded-full tw-animate-spin" />
        Test loopt...
      </span>
      <span v-else class="tw-flex tw-items-center tw-justify-center tw-gap-1">
        <lightning-bolt-icon class="tw-w-4 tw-h-4" /> Productietest
      </span>
    </button>
    <button
      v-if="can('live')"
      class="tw-flex-1 tw-bg-blue-600 hover:tw-bg-blue-700 tw-text-white tw-rounded-lg tw-py-2 tw-px-3 tw-font-semibold tw-text-sm tw-transition-colors disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
      @click="$emit('live-production')"
      :disabled="isFetchingLive"
      title="Leest spanning en stroom rechtstreeks uit de meter uit"
    >
      <span v-if="isFetchingLive" class="tw-flex tw-items-center tw-justify-center tw-gap-1">
        <span class="tw-w-3 tw-h-3 tw-border-2 tw-border-white tw-border-t-transparent tw-rounded-full tw-animate-spin" />
        Uitlezen...
      </span>
      <span v-else class="tw-flex tw-items-center tw-justify-center tw-gap-1">
        <lightning-bolt-icon class="tw-w-4 tw-h-4" /> Live productie
      </span>
    </button>
    <button
      v-if="can('history')"
      class="tw-bg-gray-100 hover:tw-bg-gray-200 tw-text-gray-600 tw-rounded-lg tw-py-2 tw-px-3 tw-text-sm tw-transition-colors tw-flex tw-items-center tw-gap-1"
      @click="$emit('show-commands')"
      :title="isC4a ? 'Toon historische commando\'s uit Cast4all (registraties, verbindingstesten, polls, tijdsync)' : 'Toon historische commando\'s (polls, pings, breaker acties)'"
    >
      <svg class="tw-w-4 tw-h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      Historie
    </button>
  </div>
</template>

<script setup>
import { WifiIcon, RefreshIcon, LightningBoltIcon } from '@vue-hero-icons/outline'

const props = defineProps({
  // what this kind of meter supports: ping, poll, live, pv-test, history (see METER_CAPABILITIES)
  capabilities: { type: Array, default: () => [] },
  isPinging: { type: Boolean, default: false },
  isPolling: { type: Boolean, default: false },
  isFetchingLive: { type: Boolean, default: false },
  isC4a: { type: Boolean, default: false },
  isRunningPvTest: { type: Boolean, default: false },
})

defineEmits(['ping', 'poll', 'live-production', 'pv-production-test', 'show-commands'])

const can = (action) => props.capabilities.includes(action)
</script>
